import { Layout } from 'antd';
import { NAV_TYPE_SIDE, SIDE_NAV_DARK, SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { connect } from 'react-redux';

import MenuContent from './MenuContent';

const { Sider } = Layout;

export const SideNav = ({
  navCollapsed,
  sideNavTheme,
  routeInfo,
  hideGroupTitle,
  getSideMenuList,
  localization = true,
}) => {
  const props = {
    sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization,
    getSideMenuList,
  };
  return (
    <Sider
      className={`side-nav ${
        sideNavTheme === SIDE_NAV_DARK ? "side-nav-dark" : ""
      }`}
      width={SIDE_NAV_WIDTH}
      collapsed={navCollapsed}
    >
      <Scrollbars autoHide>
        <MenuContent
          type={NAV_TYPE_SIDE}
          {...props}
          newSideMenuItems={props?.getSideMenuList?.data?.data || []}
        />
      </Scrollbars>
    </Sider>
  );
};

const mapStateToProps = ({ theme, sidemenu }) => {
  const { navCollapsed, sideNavTheme } = theme;
  return { navCollapsed, sideNavTheme, ...sidemenu };
};

export default connect(mapStateToProps)(SideNav);
